export default {
  point: 'point',
  point_other: 'points',
  titles: {
    earn: 'Earn points, get discounts 💵',
    redeem: '{{discount}}% unlocked 🥳',
  },
  description:
    'After you use your points to get discounts for your next order, your points will not reset to 0. But you will continue collecting points from {{points}}.',
};
